import { FC, useMemo } from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { User } from '../Home/components/User';
import { Footer } from '../../components/Footer';
import PageTitle from '../../components/PageTitle';
import { COLORS, FONTS } from '../../constants';
import { CartTable } from './components/CartTable';
import CartCollapseItem from './components/CartCollapseItem';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux';
import { deleteItem } from '../../services/redux/reducers/CartSlice';

const Cart: FC = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();
  const { cartItems } = useSelector((redux: RootState) => redux.cartReducer);

  const handleRemoveItem = (id: string) => {
    dispatch(deleteItem(id));
  };

  const renderHeaderContent = useMemo(() => {
    const contents = [
      {
        title: 'CAMP',
        width: '33%',
      },
      {
        title: 'DATE',
        width: '33%',
      },
      {
        title: 'PRICE',
        width: '33%',
      },
    ];

    return contents.map((content, index) => (
      <View
        style={{
          width: content.width,
          alignItems: 'center',
        }}
        key={content.title}
      >
        <Text style={styles.th_text}>{content.title}</Text>
      </View>
    ));
  }, []);

  if (isDesktop()) {
    return (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View
          style={{
            maxWidth: 1250,
            width: '90%',
            marginHorizontal: 'auto',
            paddingTop: 40,
            minHeight: 700,
          }}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
            }}
          >
            <View style={{ width: '20%', minWidth: 230, marginRight: 20 }}>
              <User />
            </View>
            <View style={{ width: '70%' }}>
              <PageTitle title="Shopping cart" haveGoBackButton={true} />
              <View
                style={{
                  flexDirection: 'column',
                  backgroundColor: COLORS.WHITE,
                  borderRadius: 18,
                  shadowColor: '#F0F0F0',
                  shadowOffset: { width: 0, height: 12 },
                  shadowOpacity: 1,
                  shadowRadius: 32,
                  elevation: 20,
                  overflow: 'hidden',
                }}
              >
                <View style={styles.thead}>{renderHeaderContent}</View>
                <View
                  style={{
                    padding: 10,
                    paddingTop: 15,
                  }}
                >
                  {cartItems &&
                    cartItems.map((item) => {
                      return (
                        <CartCollapseItem
                          cartItem={item}
                          onRemove={() => {
                            handleRemoveItem(item.id);
                          }}
                        />
                      );
                    })}
                </View>
              </View>
            </View>
          </View>
        </View>
        <Footer />
      </ScrollView>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <PageTitle title={'CART'} haveGoBackButton={true} />
      <View
        style={{
          backgroundColor: COLORS.WHITE,
        }}
      >
        <View
          style={{
            flexDirection: 'column',
          }}
        >
          <View style={styles.thead}>{renderHeaderContent}</View>
          <View
            style={{
              padding: 10,
              paddingTop: 15,
            }}
          >
            {cartItems &&
              cartItems.map((item) => {
                return (
                  <CartCollapseItem
                    cartItem={item}
                    onRemove={() => {
                      handleRemoveItem(item.id);
                    }}
                  />
                );
              })}
          </View>
        </View>
      </View>
      <Footer />
    </ScrollView>
  );
};

export default Cart;

const styles = StyleSheet.create({
  th_text: {
    fontSize: 19,
    fontFamily: FONTS.AvenirRegular,
    color: '#fff',
    textTransform: 'uppercase',
    fontWeight: '800',
  },
  thead: {
    flexDirection: 'row',
    paddingVertical: 8,
    backgroundColor: COLORS.RED_PRIMARY,
  },
});
